import { createAsyncThunk } from '@reduxjs/toolkit';

import { ExtendedAxiosRequestConfig } from 'shared/api/types';

import { FETCH_ABORTED } from '../../consts/catalogItemsConsts';
import {
    CatalogItem,
    CatalogItemsRequestData,
    GlobalCatalogItem,
} from '../../types/CatalogItemSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchCatalogItems = createAsyncThunk<
    CatalogItem[] | GlobalCatalogItem[],
    CatalogItemsRequestData,
    ThunkConfig<string>
>(
    'catalogItem/fetchCatalogItems',
    async ({ data, abortController }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        const { catalogId, categoryId, searchStr, isInventory } = data;

        try {
            const config: ExtendedAxiosRequestConfig = {
                params: {
                    categoryId,
                    searchStr,
                    is_loading_proposals: false,
                    ...(isInventory && { is_inventory: isInventory }),
                },
                signal: abortController?.signal,
                keysToNotConvert: ['specifications'],
            };

            const response = await extra.api.get<
                CatalogItem[] | GlobalCatalogItem[]
            >(`/v1/catalogs/${catalogId}`, config);

            return response.data;
        } catch (e) {
            const isAborted =
                (e as { code?: string })?.code === 'ERR_CANCELED' ||
                (e as { name?: string })?.name === 'AbortError';
            if (isAborted) {
                return rejectWithValue(FETCH_ABORTED);
            }
            return rejectWithValue('error');
        }
    },
);
